"use client";

import {useState} from "react";
import styles from "./isLiveBadge.module.css";

function FlaskIcon() {
	return (
		<svg
			className={styles.icon}
			viewBox="108 228 275 220"
			fill="currentColor"
			aria-hidden
		>
			<path d="M224.722 236.575c-9.782 0-17.708 7.926-17.708 17.705 0 9.34 7.234 16.97 16.4 17.642v55.87c-28.58 36.404-82.428 105.22-82.428 105.22l-.402.513-.326.565c-3.052 5.275-6.05 12.682-6.05 21.627 0 21.806 18.014 39.72 39.72 39.72h164.03c21.61 0 39.722-17.74 39.722-39.72 0-10.147-4.44-17.756-6.705-21.65l-.336-.575-82.17-103.81v-57.895c8.58-1.23 15.18-8.587 15.18-17.506 0-9.778-7.928-17.704-17.707-17.704-9.78 0-17.71 7.926-17.71 17.705 0 2.573.562 5.01 1.548 7.214v74.69l38.976 49.238H201.988c13.525-17.267 27.954-35.69 38.12-48.635l1.996-2.54V257.62c.206-1.082.326-2.196.326-3.34 0-9.778-7.93-17.704-17.71-17.704z" />
			<path d="M207 236.5H305V254.3H207Z" />
		</svg>
	);
}

/** Fixed badge shown when office IPs preview a non-live experiment page. */
export function IsLiveBadge() {
	const [dismissed, setDismissed] = useState(false);

	if (dismissed) {
		return null;
	}

	return (
		<button
			type="button"
			className={styles.badge}
			title="Experiment page (not live). Click to dismiss."
			aria-label="Experiment page (not live). Click to dismiss."
			onClick={() => setDismissed(true)}
		>
			<FlaskIcon />
		</button>
	);
}
